import React from 'react';
import { Table, Tr, Td, Thead, Th } from 'reactable';

import CountryAssistanceOECDModal from './CountryAssistanceOECDModal';

const columnsByType = {
  provided: ['Year', 'Recipient', 'Channel of delivery', 'Project title', 'Long description'],
  received: ['Year', 'Donor', 'Channel of delivery', 'Project title', 'Long description']
};

class CountryAssistanceOECDTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      modalContent: ''
    };

    this.handleDescriptionClick = this.handleDescriptionClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleDescriptionClick(content) {
    return () => {
      this.setState({
        modalOpen: true,
        modalContent: content
      });
    }
  }

  handleCloseModal() {
    this.setState({
      modalOpen: false,
      modalContent: ''
    });
  }

  renderThead() {
    const columns = columnsByType[this.props.type];

    return columns.map((column, index) => {
      return (
        <Th key={ index } column={ column }>
          { column }
        </Th>
      );
    });
  }

  renderTds(rowData) {
    return Object.keys(rowData).map(key => {
      let content;

      if (key === 'Long description') {
        content = (
          <a onClick={ this.handleDescriptionClick(rowData[key]) }>
            Link
          </a>
        );
      } else {
        content = rowData[key];
      }

      return (
        <Td key={ key } column={ key }>
          { content }
        </Td>
      )
    });
  }

  renderTrs() {
    const data = this.props.data;
    return data.map((row, index) => {
      return (
        <Tr key={ index }>{ this.renderTds(row) }</Tr>
      );
    });
  }

  renderNoData() {
    const type = this.props.type;

    return (
      <div className="no-needs-message">
        No { type } projects reported
      </div>
    );
  }

  render() {
    const data = this.props.data,
      { modalOpen, modalContent } = this.state;

    if (!data || data.length === 0) return this.renderNoData();

    return (
      <div className="oecd-table__container">
        <Table
          className="table oecd-table"
        >
          <Thead>
            { this.renderThead() }
          </Thead>
          { this.renderTrs() }
        </Table>

        <CountryAssistanceOECDModal
          content={ modalContent }
          show={ modalOpen }
          onClose={ this.handleCloseModal }
        />
      </div>
    );
  }
}

export default CountryAssistanceOECDTable;



// WEBPACK FOOTER //
// ./src/components/CountryAssistance/CountryAssistanceOECDTable.js